//
//
export default [
  {
    name: "contractCreatorExtern",
    path: "/contract",
    meta: {
      navbarTitle: "Chat", // Titel für deine App-Bar
      hideBottomNavigation: true, // Oder true, je nachdem
      hideAvatar: true,
      hideLogo: true,
      hideAppBar: true,
      fullWidth: true, // Lässt den Chat die volle Breite nutzen
    },
    component: () => import(/* webpackChunkName: "user" */ "@/views/dashboard/contract/contractCreatorExtern.vue"),
  },
  {
    name: "contractCreatorExternForm",
    path: "/contract/create/:id/:studioId",
    // component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/contract/contractCreator.vue"),
    component: () => import(/* webpackChunkName: "user" */ "@/views/dashboard/contract/contractCreator.vue"),
    meta: { displayedTitle: "Vertrag Erstellen" },
  },
  {
    name: "contractCreatorExternForm",
    path: "/contract/create/:id/:studioId/:skipPresale",
    component: () => import(/* webpackChunkName: "user" */ "@/views/dashboard/contract/contractCreator.vue"),
    meta: { displayedTitle: "Vertrag Erstellen" },
  },
]
